import React, { useEffect, useState } from "react";
import LeftBar from "../Components/LeftBar";
import NavBarAccount from "../Components/NavBarAccount";
import { getFirestore, collection, query, where, getDocs, orderBy, updateDoc, setDoc, Timestamp, doc, getDoc } from "firebase/firestore";
import { Modal, Button, Form, Table, Alert } from "react-bootstrap";
import { app } from "../firebase";
import { getAuth, onAuthStateChanged } from "firebase/auth";
import swal from 'sweetalert'; 
import {useNavigate } from "react-router-dom"; 

function RedeemPoints() {
  const [showModal, setShowModal] = useState(false);
  const [phone, setPhone] = useState("");
  const [customer, setCustomer] = useState(null);
  const [pointsToUse, setPointsToUse] = useState(0);
  const [serviceWorth, setServiceWorth] = useState("");
  const [error, setError] = useState("");
  const [successMsg, setSuccessMsg] = useState("");
  const [redeemData, setRedeemData] = useState([]);
  const [otpSent, setOtpSent] = useState(false);
  const [otp, setOtp] = useState("");
  const [generatedOtp, setGeneratedOtp] = useState("");

  const auth = getAuth();
  const db = getFirestore(app);

  const [userId, setUserId] = useState("");
  const [userName, setUserName] = useState();
  const [pointValue, setPointValue] = useState("");
  const [status, setStatus] = useState("");
  const [subscriptionStatus, setSubscriptionStatus] = useState("Unsubscribed");
  const [purchasedSMS, setPurchasedSMS] = useState();
  const [myissuedSMS, setMyissuedSMS] = useState();
  const [myTotalSMS, setMyTotalSMS] = useState();

  const [totalPoints, setTotalPoints] = useState(0);
  const [redeemedPoints, setRedeemedPoints] = useState(0);
  const [availablePoints, setAvailablePoints] = useState(0);

  const navigate = useNavigate();


  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (user) => {
      if (user) {
        const uid = user.uid;
        setUserId(uid);
        loadSettings(uid);
        fetchUserStatus(uid);

        const q = query(
          collection(db, "redeemedPoints"),
          where("businessId", "==", uid),
          orderBy("timestamp", "desc")
        );
        const querySnapshot = await getDocs(q);
        const RedeemList = querySnapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));
        setRedeemData(RedeemList);
      }
    });
    return () => unsubscribe();
  }, []);

  const loadSettings = async (uid) => {
    const docRef = doc(db, "settings", uid);
    const docSnap = await getDoc(docRef);
    if (docSnap.exists()) {
      const data = docSnap.data();
      setPointValue(data.pointValue || "");   
    }
  };

  const fetchUserStatus = async (uid) => {
    const userQuery = query(collection(db, "users"), where("userId", "==", uid));
    const querySnapshot = await getDocs(userQuery);
    querySnapshot.forEach((docSnap) => {
      const data = docSnap.data();
      setStatus(data.status || "Unsubscribed");
      setUserName(data.businessName);
      setPurchasedSMS(data.purchasedSMS);
      setMyissuedSMS(data.issuedSMS);
      const totalSMS = parseInt(data.issuedSMS) + data.purchasedSMS;
      setMyTotalSMS(totalSMS);

      const subscriptionEnd = data.subscriptionEnd?.toDate?.();
      if (subscriptionEnd) {
        const now = new Date();
        const isExpired = now > subscriptionEnd;
        setSubscriptionStatus(isExpired ? "Expired" : "Active");
      } else {
        setSubscriptionStatus("Unsubscribed");
      }
    });
  };

  const searchCustomer = async () => {
    setCustomer(null);
    setError("");
    setSuccessMsg("");
    setTotalPoints(0);
    setRedeemedPoints(0);
    setAvailablePoints(0);

    if (!phone.match(/^(\+254|254|0)?(1|7)\d{8}$/)) {
      swal('Error', "Please enter a valid name and phone number", 'error');
      return;
    }

    const formattedPhone = formatPhoneNumber(phone);
    

    const q = query(
      collection(db, "rewardCustomers"),
      where("businessId", "==", userId),
      where("phone", "==", formattedPhone)
    );

    const querySnapshot = await getDocs(q);

    if (!querySnapshot.empty) {
      const doc = querySnapshot.docs[0];
      const data = doc.data();
      const total = querySnapshot.size;

      setCustomer({ id: doc.id, ...data });
      setTotalPoints(total);

      const redeemQuery = query(
        collection(db, "redeemedPoints"),
        where("businessId", "==", userId),
        where("phone", "==", formattedPhone)
      );
      const redeemSnapshot = await getDocs(redeemQuery);
      let redeemedTotal = 0;
      redeemSnapshot.forEach(doc => {
        const redeemedData = doc.data();
        redeemedTotal += redeemedData.pointsUsed || 0;
      });

      const available = total - redeemedTotal;
      setRedeemedPoints(redeemedTotal);
      setAvailablePoints(available >= 0 ? available : 0);
    } else {
      setError("Customer not found.");
    }
  };

  const sendOtp = () => {

    const formattedPhone = formatPhoneNumber(phone);
    if (!formattedPhone) {
      setError("Please enter phone number.");
      return;
    }

    if (subscriptionStatus === "Expired"){
        swal('Subscription Expired', "Your subscription to this platform has expired. Renew your subscription to continue", 'info').then(()=>{
            navigate("/settings");
        })
        return;
    }

    const availablePointsWorth = pointValue * availablePoints;

    if (parseInt(serviceWorth) > availablePointsWorth) {
      setError("Insufficient points to redeem this amount.");
      return;
    }


    //withdraw 1sms here. check if sms is available and withdraw 
    const newmyissuedSMS = parseInt(myissuedSMS);
    console.log(newmyissuedSMS)
    
    if (newmyissuedSMS >0){
        const newSMSBalance = newmyissuedSMS - 1;
        const savedSMSBalance = String(newSMSBalance);

        const userDocRef = doc(db, "users", userId); 
        updateDoc(userDocRef, {
          issuedSMS: savedSMSBalance,
        }).then(()=>{     
            
            const generated = Math.floor(100000 + Math.random() * 900000).toString();
            setGeneratedOtp(generated);
            setOtpSent(true);
            const message = `Your OTP to reedem KES. ${serviceWorth} at ${userName} is ${generated}. Show this code to the attendant to complete the process.`
            sendSms(message, formattedPhone);
            swal("OTP Sent", `Ask the customer to show you the OTP sent to their phone to complete the process`, "info"); // Simulate SMS
            fetchUserStatus(userId);
        })

    }else if (purchasedSMS > 0){
        const newSMSBalance = purchasedSMS -1;

        const userDocRef = doc(db, "users", userId); 
        updateDoc(userDocRef, {
          purchasedSMS: newSMSBalance,
        }).then(()=>{     

            const generated = Math.floor(100000 + Math.random() * 900000).toString();
            setGeneratedOtp(generated);
            setOtpSent(true);
            const message = `Your OTP to reedem KES. ${serviceWorth} at ${userName} is ${generated}. Show this code to the attendant to complete the process.`
            sendSms(message, formattedPhone);
            swal("OTP Sent", `Ask the customer to show you the OTP sent to their phone to complete the process`, "info"); // Simulate SMS
            fetchUserStatus(userId);
        })
    }else{

      swal('insufficient SMS', "You have insufficient SMS credit to award a customer. Please top up your SMS balance to continue.", 'info').then(()=>{
         navigate("/settings");
      })

    }

  };

  const handleRedeem = async () => {

    const availablePointsWorth = pointValue * availablePoints;
    const mytotalPoints = parseInt(serviceWorth) / pointValue;

    const formattedPhone = formatPhoneNumber(phone);

    if (parseInt(serviceWorth) > availablePointsWorth) {
      setError("Insufficient points to redeem this amount.");
      return;
    }

    if (!otpSent) {
      setError("Please send OTP first.");
      return;
    }

    if (otp !== generatedOtp) {
      setError("Invalid OTP.");
      return;
    }

    const remoints = availablePoints - mytotalPoints;
    const remAmount =  remoints * pointValue;

     //withdraw 1sms here. check if sms is available and withdraw 
     const newmyissuedSMS = parseInt(myissuedSMS);

     console.log(newmyissuedSMS)
    
    if (newmyissuedSMS >0){

      const newDataRef = doc(collection(db, "redeemedPoints"));
      await setDoc(newDataRef, {
        phone: formattedPhone,
        pointsValue: parseInt(serviceWorth),
        businessId: userId,
        timestamp: Timestamp.now(),
        docID: newDataRef.id,
        pointsUsed: parseFloat(mytotalPoints)
      }).then(()=>{

        const newSMSBalance = newmyissuedSMS - 1;
        const savedSMSBalance = String(newSMSBalance);
        const userDocRef = doc(db, "users", userId); 
        updateDoc(userDocRef, {
          issuedSMS: savedSMSBalance,
        }).then(()=>{    

            const message = `You have successfully redeemed KES. ${serviceWorth} at ${userName}. You have ${remoints} points remaining at ${userName} worth KES. ${remAmount}.`
            sendSmsFinal(message, formattedPhone);
            fetchUserStatus(userId);
        })
      })
      //

    }else if (purchasedSMS > 0){

        console.log(purchasedSMS)

        const newDataRef = doc(collection(db, "redeemedPoints"));
          await setDoc(newDataRef, {
            phone: formattedPhone,
            pointsValue: parseInt(serviceWorth),
            businessId: userId,
            timestamp: Timestamp.now(),
            docID: newDataRef.id,
            pointsUsed: parseFloat(mytotalPoints)
          }).then(()=>{

              const newSMSBalance = purchasedSMS -1;
              const userDocRef = doc(db, "users", userId); 
              updateDoc(userDocRef, {
                purchasedSMS: newSMSBalance,
              }).then(()=>{     
                  const message = `You have successfully redeemed KES. ${serviceWorth} at ${userName}. You have ${remoints} points remaining at ${userName} worth KES. ${remAmount}.`
                  sendSmsFinal(message, formattedPhone);
                  fetchUserStatus(userId);
              })
          })

    }else{
      swal('insufficient SMS', "You have insufficient SMS credit to award a customer. Please top up your SMS balance to continue.", 'info').then(()=>{
         navigate("/settings");
      })
    }

      
   

  };

  function formatFullDate(date) {
    if (!date) return "";
    const d = date instanceof Date ? date : date.toDate();
    const day = d.getDate();
    const weekday = d.toLocaleDateString("en-KE", { weekday: "long" });
    const month = d.toLocaleDateString("en-KE", { month: "long" });
    const year = d.getFullYear();
    const time = d.toLocaleTimeString("en-KE", { hour: "numeric", minute: "2-digit", hour12: true });
    const suffix = day % 10 === 1 && day !== 11 ? "st" : day % 10 === 2 && day !== 12 ? "nd" : day % 10 === 3 && day !== 13 ? "rd" : "th";
    return `${weekday} ${day}${suffix} ${month} ${year}, ${time}`;
  }



  const sendSms = async (message, phoneNumber) => {
          const auth = getAuth();
          const user = auth.currentUser;
      
          if (!user) {
              console.error("User not logged in");
              return;
          }
      
          try {
              const token = await user.getIdToken();
      
              const response = await fetch("https://us-central1-kuzapoints.cloudfunctions.net/sms/send-sms", {
              method: "POST",
              headers: {
                  "Content-Type": "application/json",
                  Authorization: `Bearer ${token}`,
              },
              body: JSON.stringify({ message, phoneNumber }),
              });
      
              const data = await response.json();
      
              if (response.ok) {
                console.log("karibu")
              } else {
                console.log("karibu")
              }
          } catch (err) {
              console.log("karibu")
          }
    };



    const sendSmsFinal = async (message, phoneNumber) => {
        const auth = getAuth();
        const user = auth.currentUser;
    
        if (!user) {
            console.error("User not logged in");
            return;
        }
    
        try {
            const token = await user.getIdToken();
    
            const response = await fetch("https://us-central1-kuzapoints.cloudfunctions.net/sms/send-sms", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`,
            },
            body: JSON.stringify({ message, phoneNumber }),
            });
    
            const data = await response.json();
    
            if (response.ok) {
              swal("Success!", "You have redeemed points successfully", "success").then(() => {
              window.location.reload();
            });
            return false;
            } else {
              swal("Success!", "You have redeemed points successfully", "success").then(() => {
                window.location.reload();
              });
              return false;
            }
        } catch (err) {
            swal("Success!", "You have redeemed points successfully", "success").then(() => {
              window.location.reload();
            });
            return false;
        }
    };

  
  const formatPhoneNumber = (number) => {
    // Strip non-numeric characters
    let cleaned = number.replace(/[^0-9]/g, '');

    // Handle various cases
    if (cleaned.startsWith('0')) {
      cleaned = '254' + cleaned.slice(1); // Replace leading 0 with 254
    } else if (cleaned.startsWith('254')) {
      // No change needed
    } else if (cleaned.startsWith('7')) {
      cleaned = '254' + cleaned; // Add 254 if starts with 7
    } else if (cleaned.startsWith('+254')) {
      cleaned = cleaned.slice(1); // Remove the + sign
    } else if (cleaned.startsWith('1')) {
      cleaned = '254' + cleaned; // For landlines or similar cases starting with 1
    }

    // Ensure the number has 12 digits
    if (cleaned.length === 12 && cleaned.startsWith('254')) {
      return cleaned;
    } else {
      setError('Please enter a valid phone number in the format 254XXXXXXXXX');
      return null;
    }
  };

  return (
    <div className="dashBCont">
      <LeftBar />
      <div className="dashBcontA">
        <NavBarAccount />
        <div className="container mt-5">

        <div className="d-flex justify-content-between align-items-center mb-3">
          <h4>Redeemed History</h4>

          <Button onClick={() => setShowModal(true)} className="myPrimaryBtn">Redeem Points</Button>
        </div>
          
          <Table striped bordered hover responsive>
            <thead>
              <tr>
                <th>Phone</th>
                <th>Points Used</th>
                <th>Reward Value</th>
                <th>Date</th>
              </tr>
            </thead>
            <tbody>
              {redeemData.length > 0 ? (
                redeemData.map((item) => (
                  <tr key={item.id}>
                    <td>{item.phone || "—"}</td>
                    <td>{item.pointsUsed}</td>
                    <td>KES. {item.pointsValue}</td>
                    <td>{formatFullDate(item.timestamp)}</td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="4" className="text-center">No Redeemed Points yet.</td>
                </tr>
              )}
            </tbody>
          </Table>
        </div>

        <Modal show={showModal} onHide={() => setShowModal(false)}>
          <Modal.Header closeButton>
            <Modal.Title className="myPrimaryColor">Redeem Points</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {error && <Alert variant="danger">{error}</Alert>}
            {successMsg && <Alert variant="success">{successMsg}</Alert>}
            <div>
              <Form.Group controlId="formPhone">
                <Form.Label>Customer Phone Number</Form.Label>
                <Form.Control type="text" placeholder="eg 07XXX" value={phone} onChange={(e) => setPhone(e.target.value)} />
                <Button  className="myPrimaryBtn mt-2"onClick={searchCustomer}>Search</Button>
              </Form.Group>

              {customer && (
                <>
                  <div className="mt-3">
                    <p><strong>Phone:</strong> {customer.phone}<br />
                    <strong>Total Earned Points:</strong> {totalPoints}<br />
                    <strong>Redeemed Points:</strong> {redeemedPoints}<br />
                    <strong>Available Points:</strong> {availablePoints}<br />
                    <strong>Available Points Worth:</strong> KES. {availablePoints * pointValue}</p>
                  </div>
                  <Form.Group controlId="formAmount">
                    <Form.Label>Enter Reward Worth in KES below</Form.Label>
                    <Form.Control
                      type="number"
                      placeholder="eg. 300"
                      value={serviceWorth}
                      onChange={(e) => setServiceWorth(e.target.value)}
                    />
                  </Form.Group>

                  {!otpSent ? (
                    <Button  className="myPrimaryBtn mt-3" onClick={sendOtp}>Send OTP to the customer</Button>
                  ) : (
                    <Form.Group controlId="otpCode" className="mt-3">
                      <Form.Label>Enter OTP sent to confirm</Form.Label>
                      <Form.Control
                        type="text"
                        value={otp}
                        onChange={(e) => setOtp(e.target.value)}
                        placeholder="Enter 6-digit OTP"
                      />
                    </Form.Group>
                  )}
                </>
              )}
            </div>
          </Modal.Body>
          {otpSent && (
            <Modal.Footer>
              <Button variant="secondary" className="btn-sm" onClick={() => setShowModal(false)}>Cancel</Button>
              <Button className="myPrimaryBtn" onClick={handleRedeem}>Redeem</Button>
            </Modal.Footer>
          )}
        </Modal>
      </div>
    </div>
  );
}

export default RedeemPoints;
